import { render, staticRenderFns } from "./ComTableCopy.vue?vue&type=template&id=47c943c4&scoped=true&"
import script from "./ComTableCopy.vue?vue&type=script&lang=js&"
export * from "./ComTableCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c943c4",
  null
  
)

export default component.exports